const initFilter = ($) => {
	const $filter = $('.widget_filters');

	if (!$filter.length) {
		return;
	}

	$(document).on('change', 'input[type="checkbox"]', function (e) {
		e.preventDefault();

		const $catFilters = $('.js-category input[type="checkbox"]', $filter)
			.filter(':checked')
			.map(function () {
				return this.value;
			})
			.get()
			.join('|');

		const $tagFilters = $('.js-tags input[type="checkbox"]', $filter)
			.filter(':checked')
			.map(function () {
				return this.value;
			})
			.get()
			.join('|');

		let qs = '?qs=1';

		if ($catFilters) {
			qs += '&cats=' + $catFilters;
		}

		if ($tagFilters) {
			qs += '&tags=' + $tagFilters;
		}

		window.location.href = qs;
	});
};

export default initFilter;